var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-button-component"},[_c('transition',{attrs:{"name":"sticky-fade"}},[(_vm.isVisible)?_c('div',{staticClass:"sticky-fixed"},[_c('div',{staticClass:"sticky-button",class:{ 'mode-page-services' : _vm.$route.meta.hideNavigation },on:{"click":_vm.backToTop}},[_c('span')])]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }